import React from 'react';

export const InputBox = ({
  label,
  name = '',
  value = '',
  type = 'text',
  placeholder = '',
  onChange,
  submitted,
  disabled = false,
}) => {
  return (
    <div className={'inputcontainer' + (submitted && !value ? ' invalid-input' : '')}>
      <div className='input_label'>{label}</div>
      <input
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        className='inputbox'
        disabled={disabled}
      />
    </div>
  );
};
